/* 
Author:Lamiaa Moustafa
Desc: Error page UI
*/

import React from "react";
import errorGraphic from "../../assets/svgs/errorGraphic.svg";
import { Footer1st2911 } from "../../components/Footer1st2911";
import { ErrorDiv } from "../../Styles/styledComponents/Divs";
import{HeadlineText, SubTitle} from "../../Styles/styledComponents/Text"
import { Nav1st2911 } from "../../components/Nav1st2911";

const NotFound = () => {
  return (
    <>
     <Nav1st2911/>
      <ErrorDiv>
       <HeadlineText> Oops!</HeadlineText>
       <SubTitle>Error 404 - Page Not Found</SubTitle>
       <p> The page you requested could not be found. We are working on it </p>

        <img className="RobotSvg" src={errorGraphic} alt="404 error graphic" />
      </ErrorDiv>
      <Footer1st2911 />
    </>
  );
};
export default NotFound;

